
/**
 * @name APP cmmApp
 * @autor daniel.molina@u-planner.com
 * @description vista tabla para forecast
 * # name controller --> powerbiPortofolioCtrl
 * # alias: --> powerbiCtrl
 */
 export default class powerbiWorkPlanCtrl{
	constructor($http, $scope, $state, $stateParams, ngNotify, $timeout, UserInfoConstant,LOCAL_ENV_CONSTANT) {
           
           	$scope.title='Reporte Plan de Trabajo Profesores'

           	$scope.POWER=LOCAL_ENV_CONSTANT.POWERBI_CONSTANT.CLIENT_REPORT.REPORT_FACULTY3;

           	$scope.workspaceId=LOCAL_ENV_CONSTANT.POWERBI_CONSTANT.CLIENT_GROUP_ID;
           	$scope.reportId=LOCAL_ENV_CONSTANT.POWERBI_CONSTANT.CLIENT_REPORT.REPORT_FACULTY3;
   }

}

powerbiWorkPlanCtrl.$inject = ['$http', '$scope', '$state', '$stateParams', 'ngNotify', '$timeout', 'UserInfoConstant','LOCAL_ENV_CONSTANT'];


// WEBPACK FOOTER //
// ./src/app/u-faculty/report/reportWorkPlanPowerbi/powerbiWorkPlanCtrl.js